export default __webpack_public_path__ + "files/UpwardTrendIcon-1936d45090e3238d44555644d32c3953.png";